module.exports = __webpack_public_path__ + "img/smoko.639d3210.png";